import { useCurrentUser } from 'Auth';
import { create } from 'components/Presets/data/queryKeyFactory';
import { savePreset } from 'components/Presets/sources/presets';

import { useMutation } from '@gogame/query';

export const useCreatePreset = (presetKey) => {
  const currentUser = useCurrentUser();

  const createMutation = useMutation(
    create(),
    (p) =>
      savePreset({
        ...p,
        screen: presetKey,
      }),
    {
      successMessage: () => `Preset added`,
    }
  );

  const handleAction = (data) => {
    const user = { name: currentUser.name, id: currentUser.id };
    return createMutation.mutateAsync({ ...data, user });
  };
  return [handleAction, createMutation];
};
